var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimelineConnector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "23px",
    height: "479px",
    viewBox: "0 0 23 479",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "New-Site",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agility-Partners__Home",
    transform: "translate(-705.000000, -1391.000000)",
    stroke: "#77778B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.207304,1391 C724.453165,1417 724.289863,1446.33333 719.717397,1479 C712.858699,1528 706,1547 706,1575 C706,1601.46084 722.488263,1617.74238 726.576096,1653 C729.496,1678.18422 716.50496,1699.65945 712.858699,1724 C709.174083,1748.59658 726.576096,1783.9815 726.576096,1794.5 C726.576096,1818.16667 726.576096,1843.33333 726.576096,1870",
    id: "Path-5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineConnector);
export default __webpack_public_path__ + "static/media/timeline_connector.3cbd2d96.svg";
export { ForwardRef as ReactComponent };